import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { KlmrTimesheetHistoryPage } from './klmr-timesheet-history';

@NgModule({
  declarations: [
    KlmrTimesheetHistoryPage,
  ],
  imports: [
    IonicPageModule.forChild(KlmrTimesheetHistoryPage),
  ],
})
export class KlmrTimesheetHistoryPageModule {}



// WEBPACK FOOTER //
// ./src/pages/klmr-timesheet-history/klmr-timesheet-history.module.ts